/*
 * Copyright (C) GMS Inc - All Rights Reserved
 * This file is part of GMSCloud. - Proprietary and confidential
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Created on   :
 * @author      : Kanimozhi.S
 * @since       : 0.0.1
 * Requirement# :
 * Purpose      : Features
 * -----------------------------------------------------------------------------
 * Revision History
 * -----------------------------------------------------------------------------
 * Requirement/
 * Issue/WorkItem |   DATE        |   AUTHOR     |   DESCRIPTION OF CHANGE
 * -----------------------------------------------------------------------------
 * 4037           |  01-04-2025   |   Kanimozhi  | List the Third party service and add new service ui implementation and data bind
 *
 *
 */
import * as React from "react";
import Box from "@mui/material/Box";
import {
  Grid,
  Card,
  Tabs,
  Tab,
  Typography,
  Button,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  DialogContentText,
  Fade,
} from "@mui/material";
import ThirdPartyConfiguration from "../../pages/Configuration/Configuration";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  createService,
  getAllServices,
  updateMasterSwitch,
} from "../../services/ExternalService";
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomDialog from "../../pages/Dialog";
import "./Features.scss";
import { useState } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const FeaturesConfiguration: React.FC = () => {
  const [value, setValue] = React.useState(0);
  const [showConfigTab, setShowConfigTab] = React.useState(false);
  const [configTabLabel, setConfigTabLabel] = React.useState("Configuration");
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [openWarningDialog, setOpenWarningDialog] = React.useState(false);
  const [confirmationUpdate, setConfirmationUpdate] = React.useState(false);
  const { accessToken, accessTokenPayload } = useOidcAccessToken();
  const [createSuccess, setCreateSuccess] = React.useState<any>(false);
  const [error, setError] = React.useState<any>(false);
  const [service, setService] = React.useState<any>([]);
  const [serviceName, setServiceName] = React.useState("");
  const [serviceId, setServiceId] = React.useState<any>([]);
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
  const [confirmationDialog, setConfirmationDialog] = React.useState<string | null>(null);
  const [pendingToggle, setPendingToggle] = useState<{

    serviceId: any;
  } | null>(null);

  const [successMessage, setSuccessMessage] = React.useState<string | null>(
    null
  );
  const [isSaving, setIsSaving] = useState(false); // NEW

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (newValue === 0) {
      setShowConfigTab(false);
    }
  };

  function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }




  const handleToggle = async (index: number, serviceId: string) => {
    console.log('serviceId:', serviceId);

    const response = await getAllServices(accessToken);

    if (!response || !response.data) {
      console.error('Invalid response from getAllServices');
      return;
    }

    const matchedService = response.data.find((s: any) => s.serviceUid === serviceId);

    if (!matchedService) {
      console.error('Service not found in fetched data.');
      return;
    }

    console.log('Matched service:', matchedService);

    if (matchedService.status === "Active") {
      setConfirmationDialog("Are you sure you want to disable this service?");
      setPendingToggle({ serviceId }); // No index needed
      setConfirmationUpdate(true);
    } else {
      proceedToggle(serviceId); // No index needed
    }
  };


  const proceedToggle = async (serviceId: string) => {
    let newStatus = "";

    // Update only the service that matches the serviceId
    setService((prevData) =>
      prevData.map((item) => {
        if (item.serviceUid === serviceId) {
          newStatus = item.status === "Active" ? "InActive" : "Active";
          return { ...item, status: newStatus };
        }
        return item;
      })
    );

    const param = {
      serviceUid: serviceId,
      status: newStatus,
      createdBy: accessTokenPayload.oid,
      invalid: false,
    };

    try {
      const response = await updateMasterSwitch(param, accessToken);
      console.log("res", response);
      if (response.data === 200) {
        // Optionally show a success toast or reload services
      }
    } catch (error) {
      console.error("Error updating service status:", error);
    }
  };

  const handleSettingsClick = (id: any, name: string) => {
    setShowConfigTab(true);
    setConfigTabLabel(`${name} Configuration`);
    setServiceName(name);
    setServiceId(id);
    console.log("serviceId", id);
    setValue(1);
  };
  const getDefaultFeature = () => ({
    name: "",
    serviceType: "",
    createdBy: accessTokenPayload.oid,
    description: "",
    status: "InActive",
    invalid: false,
  });

  const handleOpenDialog = () => {
    setOpenDialog(true);
    setNewFeature(getDefaultFeature());
  };


  const handleConfirm = () => {
    if (pendingToggle) {
      proceedToggle(pendingToggle.serviceId);
      setPendingToggle(null);
    }
    setConfirmationUpdate(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setOpenWarningDialog(false);
    setOpenSuccess(false);
    setPendingToggle(null);
    setConfirmationUpdate(false);
  };
  const [newFeature, setNewFeature] = React.useState<any>({
    name: "",
    serviceType: "",
    createdBy: accessTokenPayload.oid,
    description: "",
    status: "InActive",
    invalid: false,
  });

  const handleSaveFeature = async () => {
    if (isSaving) return;
    setIsSaving(true);

    try {
      const response = await createService(newFeature, accessToken);
      if (response?.data) {

        fetchData();
        setOpenDialog(false);
        setOpenSuccess(true);
        setCreateSuccess(true);
        setNewFeature({
          name: "",
          serviceType: "",
          createdBy: accessTokenPayload.oid,
          description: "",
          status: "InActive",
          serviceId: "",
          invalid: false,
        });
        // setSuccessMessage(`"${newFeature.name}" service was added successfully.`);
        setSuccessMessage(`"${newFeature.name}" service was added successfully.\nPlease set your service configuration to proceed.`);


      } else if (response.status === 500) {
        setOpenWarningDialog(true);
        setOpenDialog(false);
        setErrorMessage(
          `A service named "${newFeature.name}" already exists. Please enter a unique service name.`
        );
      }
    } catch (error: any) {
      if (error?.response?.status === 500 && error?.response?.data?.message) {
        setOpenWarningDialog(true);
        setOpenDialog(false);
        setErrorMessage(error.response.data.message);
      } else {
        setError(true);
        setErrorMessage("An unexpected error occurred.");
      }
    } finally {
      setIsSaving(false); // Always re-enable Save button
    }
  };

  const fetchData = async () => {
    const res = await getAllServices(accessToken);
    setService(res.data);
    console.log("service", res.data);
  };

  const groupServicesByType = (services: any[] = []) => {
    return services.reduce((acc, service) => {
      const type = service.serviceType || "";
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(service);
      return acc;
    }, {} as Record<string, any[]>);
  };

  const groupedServices = groupServicesByType(service);
  console.log('service', groupedServices);

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <Grid container sx={{ height: "100vh", p: 2 }}>
      <Grid item xs={12}>
        <Box>
          <Card sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  sx={{ textTransform: "none" }}
                  label="3rd Party Features"
                  {...a11yProps(0)}
                />
                {showConfigTab && (
                  <Tab
                    sx={{ textTransform: "none" }}
                    label={configTabLabel}
                    {...a11yProps(1)}
                  />
                )}
              </Tabs>
            </Box>
          </Card>

          {value === 0 && (
            <Card sx={{ width: "100%", overflowY: "auto", p: 3 }}>
              <Grid container justifyContent="flex-end" sx={{ mb: 2, mt: 0 }}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleOpenDialog}
                >
                  <AddOutlinedIcon className="personIcon" /> &nbsp; Add New
                  Service
                </Button>
              </Grid>

              {Object.keys(groupedServices).map((type, groupIndex) => (
                <Box key={groupIndex} sx={{ mb: 4 }}>
                  <Card sx={{ p: 2, m: 2 }}>
                    <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
                      {type}
                    </Typography>
                    {groupedServices[type].map((item, index) => (
                      <Card
                        key={index}
                        sx={{
                          mb: 2,
                          p: 2,
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                        }}
                      >
                        <Box sx={{ width: "100%", marginBottom: "2vh" }}>
                          <Grid container alignItems="center">
                            <Grid item xs={2}>
                              <Typography
                                variant="h6"
                                sx={{ fontSize: "20px" }}
                              >
                                {item.name}
                              </Typography>
                            </Grid>

                            <Grid
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >

                              <Switch
                                checked={item.status === "Active"}
                                onChange={() =>
                                  handleToggle(index, item.serviceUid)
                                }
                                color="primary"
                                sx={{ transform: "scale(1.8)" }}
                              />

                            </Grid>



                          </Grid>
                        </Box>
                        <Box sx={{ width: "100%" }}>
                          <Grid container alignItems="center">
                            <Grid item xs={11}>
                              <Typography variant="h4" color="textSecondary">
                                {item.description}
                              </Typography>
                            </Grid>

                            <Grid
                              item
                              xs={1}
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                fontWeight: 500,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                              >
                                <SettingsOutlinedIcon
                                  sx={{
                                    fontSize: 30,
                                    cursor:
                                      item.status === "InActive"
                                        ? "pointer"
                                        : "default",
                                  }}
                                  onClick={() =>
                                    handleSettingsClick(
                                      item.id,
                                      item.name
                                    )
                                  }
                                  className={
                                    item.status === "InActive"
                                      ? "hand-tap-animation"
                                      : ""
                                  }
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Card>
                    ))}
                  </Card>
                </Box>
              ))}
            </Card>
          )}


          {value === 1 && (
            <CustomTabPanel value={value} index={1}>
              <Box>
                <ThirdPartyConfiguration
                  serviceId={serviceId}
                  serviceName={serviceName}
                />
              </Box>
            </CustomTabPanel>
          )}

          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>Add new service</DialogTitle>
            <DialogContent>
              <TextField
                required
                autoFocus
                margin="dense"
                label="Service Type"
                fullWidth
                value={newFeature.serviceType}
                onChange={(e) =>
                  setNewFeature({ ...newFeature, serviceType: e.target.value })
                }
              />

              <TextField
                required
                margin="dense"
                label="Service Name"
                fullWidth
                value={newFeature.name}
                onChange={(e) =>
                  setNewFeature({ ...newFeature, name: e.target.value })
                }
              />

              <TextField
                margin="dense"
                label="Description"
                fullWidth
                multiline
                rows={3}
                value={newFeature.description}
                onChange={(e) =>
                  setNewFeature({ ...newFeature, description: e.target.value })
                }
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleSaveFeature}
                color="primary"
                variant="contained"
                disabled={
                  !newFeature.name || !newFeature.serviceType || isSaving
                }
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>

              <Button
                onClick={handleCloseDialog}
                className="dangerButton"
                variant="contained"
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>


          <Dialog open={openWarningDialog}>
            <DialogTitle
              className="success"
              sx={{ backgroundColor: "rgb(255,193,0) !important" }}
            >
              <Box paddingLeft={8} paddingRight={8}>
                <Typography textAlign={"center"}>
                  <InfoOutlinedIcon sx={{ fontSize: "50px", color: "white" }} />
                </Typography>
              </Box>
            </DialogTitle>
            <Box paddingLeft={8} paddingRight={8}>
              <DialogContent>
                <DialogContentText
                  textAlign={"center"}
                  fontSize={"18px"}
                  fontWeight={"500"}
                >
                  {errorMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ justifyContent: "center" }}>
                <Button
                  variant="contained"
                  className="NoChangeButton"
                  onClick={handleCloseDialog}
                >
                  Ok
                </Button>
              </DialogActions>
            </Box>
          </Dialog>





          <Dialog open={confirmationUpdate}>
            <DialogTitle
              className="success"
              sx={{ backgroundColor: "rgb(255,193,0) !important" }}
            >
              <Box paddingLeft={8} paddingRight={8}>
                <Typography textAlign={"center"}>
                  <InfoOutlinedIcon sx={{ fontSize: "50px", color: "white" }} />
                </Typography>
              </Box>
            </DialogTitle>
            <Box paddingLeft={8} paddingRight={8}>
              <DialogContent>
                <DialogContentText
                  textAlign={"center"}
                  fontSize={"18px"}
                  fontWeight={"500"}
                >
                  {confirmationDialog}
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ justifyContent: "center" }}>
                <Button
                  variant="contained"
                  className="NoChangeButton"
                  onClick={handleConfirm}
                >
                  confirm
                </Button>
                <Button
                  variant="contained"
                  className="NoChangeButton"
                  onClick={handleCloseDialog}
                >
                  Close
                </Button>
              </DialogActions>
            </Box>
          </Dialog>
          <CustomDialog
            open={openSuccess}
            onClose={handleCloseDialog}
            success={createSuccess}
            reason={undefined}
            error={error}
            Content={
              createSuccess
                ? successMessage
                : "Failed to add the service Pleace try later"
            }
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default FeaturesConfiguration;
